import "./bootstrap2/bootstrap-transition"
import "./bootstrap2/bootstrap-alert"
import "./bootstrap2/bootstrap-tab"
import "./bootstrap2/bootstrap-tooltip"
import "./bootstrap2/bootstrap-popover"
